export default {
      id: "video-event_driving-light-hit-usage",
      viewBox: "0 0 33 21",
      url: __webpack_public_path__ + "img/icons.svg#video-event_driving-light-hit",
      toString: function () {
        return this.url;
      }
    }